import React from 'react';
import BadgeStatus from '../../components/elements/BadgeStatus';
export const FAILED = 'SubMerchantActivation/failed';
export const LOADING = 'SubMerchantActivation/loading';
export const SUCCESS = 'SubMerchantActivation/success';
export const CLEAR_MESSAGE = 'SubMerchantActivation/clear_message';
export const RESET = 'SubMerchantActivation/reset';

export const validate = (values) => {
  const errors = {};
  if (!values.hargaJualMin) {
    errors.hargaJualMin = { _error: 'Harga Jual Minimum harus diisi' };
  }
  if (!values.hargaJualMax) {
    errors.hargaJualMax = { _error: 'Harga Jual Maksimum harus diisi' };
  }

  if (parseFloat(values.hargaJualMin) <= 0) {
    errors.hargaJualMin = 'Harga Jual Minimum harus diatas 0';
  }

  if (parseFloat(values.hargaJualMax) <= 0) {
    errors.hargaJualMax = 'Harga Jual Maksimum harus diatas 0';
  }

  if (parseFloat(values.hargaJualMin) > parseFloat(values.hargaJualMax)) {
    errors.hargaJualMin = 'harus lebih kecil dari harga maksimum';
    errors.hargaJualMax = 'harus lebih besar dari harga minimum';
  }
  return errors;
};

export const activationStatus = {
  ACTIVE: <BadgeStatus label="Aktif" />,
  INACTIVE: <BadgeStatus label="Tidak Aktif" />,
};
